import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import * as LeadContactService from 'services/agents/lead/contact';

export const useLeadContactService = () => {
  const { token } = useSelector((store) => store.user_data);

  const createLead = async (data, options = {}) => {
    const { error, payload: lead } = await LeadContactService.create({
      ...options,
      data,
      token
    });

    if (error) {
      toast.error('Cannot create contact at this time');
      return { lead: null };
    }

    toast.success('Contact created successfully.');
    return { lead };
  };

  const deleteLead = async (id, options = {}) => {
    const { error } = await LeadContactService.deleteOne(id, {
      ...options,
      token
    });

    if (error) {
      toast.error('Unable to delete lead at this time.');
      return false;
    }

    toast.success('Lead deleted successfully');
    return true;
  };

  const fetchLead = async (id, options = {}) => {
    const { error, payload: lead } = await LeadContactService.readById(id, { ...options, token });

    if (error) {
      toast.error(error);
      return { lead: null };
    }

    return { lead };
  };

  const fetchLeads = async (options = {}) => {
    const { error, payload } = await LeadContactService.read({ ...options, token });

    if (error) {
      toast.error(error);
      return { leads: [], size: 0 };
    }

    const {
      data: leads,
      meta: { size }
    } = payload;
    return { leads, size };
  };

  const searchLeads = async (keys, keyword, options = {}) => {
    const { error, payload } = await LeadContactService.search(keys, keyword, {
      ...options,
      token
    });
    if (error) {
      toast.error('Unable to fetch leads at this time.');
      return { leads: [], size: 0 };
    }

    const {
      data: leads,
      meta: { size }
    } = payload;
    return { leads, size };
  };

  const updateLead = async (id, options = {}) => {
    const { error } = await LeadContactService.updateById(id, {
      ...options,
      token
    });

    if (error) {
      toast.error('Unable to update lead at this time.');
      return false;
    }

    toast.success('Lead updated successfully');
    return true;
  };

  const updateLeads = async (options = {}) => {
    const { error } = await LeadContactService.update({
      ...options,
      token
    });

    if (error) {
      toast.error('Unable to update leads at this time.');
      return false;
    }

    toast.success('Leads updated successfully');
    return true;
  };

  return { createLead, deleteLead, fetchLead, fetchLeads, searchLeads, updateLead, updateLeads };
};
